import Ovace from './Ovace'
export default Ovace
